import { render, staticRenderFns } from "./ProofForm.vue?vue&type=template&id=5484af60&"
import script from "./ProofForm.vue?vue&type=script&lang=ts&"
export * from "./ProofForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProofForm.vue?vue&type=style&index=0&id=5484af60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports